__turbopack_context__.v({
  "ArrowButton": "ArrowButton-module__CsWs0q__ArrowButton",
  "icon": "ArrowButton-module__CsWs0q__icon",
  "right": "ArrowButton-module__CsWs0q__right",
});
